<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import draggable from "vuedraggable";

// 完整订单菜单
const DEFAULT_NAVBAR = [
    { id: "all", name: "全部订单", icon: "qpdingdan", count: 0 },
    { id: "payment", name: "待支付", icon: "daifukuan", count: 0 },
    { id: "delivery", name: "待发货", icon: "daifahuo", count: 0 },
    { id: "received", name: "待收货", icon: "daishouhuo", count: 0 },
];

// 完整功能菜单
const DEFAULT_MENU = [
    { id: "address", name: "收货地址", icon: "shouhuodizhi", type: "link", url: "pages/address/index" },
    { id: "card", name: "我的卡片", icon: "artboard", type: "link", url: "pages/wallet/card" },
    { id: "coupon", name: "领券中心", icon: "lingquan", type: "link", url: "pages/coupon/index" },
    { id: "myCoupon", name: "优惠券", icon: "youhuiquan", type: "link", url: "pages/my-coupon/index" },
    { id: "help", name: "我的帮助", icon: "bangzhu", type: "link", url: "pages/help/index" },
    { id: "contact", name: "在线客服", icon: "kefu", type: "tap", openType: "contact" },
    { id: "points", name: "我的积分", icon: "jifen", type: "link", url: "pages/points/log" },
    { id: "refund", name: "退换/售后", icon: "shouhou", type: "link", url: "pages/refund/index", count: 0 },
    { id: "qrcode", name: "付款码", icon: "erweima", type: "link", url: "pages/wallet/paymentqr" },
    { id: "gatecode", name: "门禁码", icon: "erweima", type: "link", url: "pages/wallet/gateqr" },
];

export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader, draggable },
    data() {
        return {
            title: "Starter page",
            items: [],
            loading: false,
            appid: "",
            userinfo: [],
            navbar: [],
            navbarAvailable: [],
            menu: [],
            menuAvailable: [],
        };
    },
    mounted() {
        this.userinfo = JSON.parse(localStorage.getItem("user") || "{}");
        this.appid = this.$route.params.appid;
        this.title = "小程序菜单";
        this.items = [
            { text: this.$t("menuitems.micoapp.text"), href: "/" },
            { text: this.$t("menuitems.icp.micoapp.list"), href: "/micoapp" },
            { text: this.$t("menuitems.icp.micoapp.info"), href: `/micoapp/${this.appid}` },
            { text: "小程序菜单", active: true },
        ];
        this.getmicoappmenu();
    },
    methods: {
        getmicoappmenu() {
            const that = this;
            that.loading = true;
            that.$axios
                .post(
                    "https://api.aicoiot.com/micoappapi.php",
                    { action: "micoapp.menu", appid: that.appid },
                    { headers: { Openid: that.userinfo.openid } }
                )
                .then(function (response) {
                    that.loading = false;
                    const data = response.data && response.data.data ? response.data.data : {};
                    that.setNavbarFromApi(data.navbar);
                    that.setMenuFromApi(data.menu);
                })
                .catch(function (error) {
                    that.loading = false;
                    that.setNavbarFromApi(null);
                    that.setMenuFromApi(null);
                    if (error && error.message) {
                        that.$notify.error({ title: "请求错误", message: error.message });
                    }
                });
        },
        parseMenuData(apiData, defaults) {
            if (!apiData) return [];
            try {
                const parsed = typeof apiData === "string" ? JSON.parse(apiData) : apiData;
                return Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                return [];
            }
        },
        setNavbarFromApi(apiData) {
            const current = this.parseMenuData(apiData, []);
            const selectedIds = new Set(current.map((x) => x.id));
            this.navbar = current;
            this.navbarAvailable = DEFAULT_NAVBAR.filter((d) => !selectedIds.has(d.id)).map((d) => ({ ...d }));
        },
        setMenuFromApi(apiData) {
            const current = this.parseMenuData(apiData, []);
            const selectedIds = new Set(current.map((x) => x.id));
            this.menu = current;
            this.menuAvailable = DEFAULT_MENU.filter((d) => !selectedIds.has(d.id)).map((d) => ({ ...d }));
        },
        saveMenu() {
            const that = this;
            that.loading = true;
            that.$axios
                .post(
                    "https://api.aicoiot.com/micoappapi.php",
                    {
                        action: "micoapp.savemenu",
                        appid: that.appid,
                        menu: JSON.stringify(that.menu),
                        navbar: JSON.stringify(that.navbar),
                    },
                    { headers: { Openid: that.userinfo.openid } }
                )
                .then(function (response) {
                    that.loading = false;
                    if (response.data.status == 200) {
                        that.$message.success({ message: "保存成功" });
                        that.getmicoappmenu();
                    } else {
                        that.$message.error({ message: response.data.message || "保存失败" });
                    }
                })
                .catch(function (error) {
                    that.loading = false;
                    that.$message.error({ message: "保存失败" });
                });
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page micoapp-menu-page">
            <div class="row" v-loading="loading">
                <div class="col-12">
                    <div class="micoapp-menu-toolbar">
                        <div class="micoapp-toolbar-title">
                            <h5>小程序菜单</h5>
                            <p>从左侧拖入右侧启用，从右侧拖回左侧移除；支持在列表内拖拽排序</p>
                        </div>
                        <el-button type="primary" size="small" @click="saveMenu">保存配置</el-button>
                    </div>
                </div>
                <!-- 订单菜单 -->
                <div class="col-12 col-lg-6">
                    <div class="card micoapp-menu-card">
                        <div class="card-body">
                            <h6 class="micoapp-menu-card-title">订单菜单</h6>
                            <p class="micoapp-menu-card-desc">订单列表页顶部标签</p>
                            <div class="micoapp-menu-panels">
                                <div class="micoapp-menu-panel">
                                    <div class="micoapp-panel-title">未应用</div>
                                    <draggable v-model="navbarAvailable" group="orderNavbar" handle=".micoapp-drag-handle" class="micoapp-drag-list">
                                        <div v-for="item in navbarAvailable" :key="'av-' + item.id" class="micoapp-menu-item">
                                            <span class="micoapp-drag-handle"><i class="el-icon-rank"></i></span>
                                            <span class="micoapp-menu-name">{{ item.name }}</span>
                                        </div>
                                    </draggable>
                                </div>
                                <div class="micoapp-menu-panel micoapp-panel-active">
                                    <div class="micoapp-panel-title">已应用</div>
                                    <draggable v-model="navbar" group="orderNavbar" handle=".micoapp-drag-handle" class="micoapp-drag-list">
                                        <div v-for="item in navbar" :key="item.id" class="micoapp-menu-item">
                                            <span class="micoapp-drag-handle"><i class="el-icon-rank"></i></span>
                                            <span class="micoapp-menu-name">{{ item.name }}</span>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 功能菜单 -->
                <div class="col-12 col-lg-6">
                    <div class="card micoapp-menu-card">
                        <div class="card-body">
                            <h6 class="micoapp-menu-card-title">功能菜单</h6>
                            <p class="micoapp-menu-card-desc">个人中心「我的」页面功能入口</p>
                            <div class="micoapp-menu-panels">
                                <div class="micoapp-menu-panel">
                                    <div class="micoapp-panel-title">未应用</div>
                                    <draggable v-model="menuAvailable" group="funcMenu" handle=".micoapp-drag-handle" class="micoapp-drag-list">
                                        <div v-for="item in menuAvailable" :key="'av-' + item.id" class="micoapp-menu-item">
                                            <span class="micoapp-drag-handle"><i class="el-icon-rank"></i></span>
                                            <span class="micoapp-menu-name">{{ item.name }}</span>
                                        </div>
                                    </draggable>
                                </div>
                                <div class="micoapp-menu-panel micoapp-panel-active">
                                    <div class="micoapp-panel-title">已应用</div>
                                    <draggable v-model="menu" group="funcMenu" handle=".micoapp-drag-handle" class="micoapp-drag-list">
                                        <div v-for="item in menu" :key="item.id" class="micoapp-menu-item">
                                            <span class="micoapp-drag-handle"><i class="el-icon-rank"></i></span>
                                            <span class="micoapp-menu-name">{{ item.name }}</span>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.micoapp-menu-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;
}
.micoapp-menu-toolbar .micoapp-toolbar-title h5 {
    margin: 0 0 0.25rem 0;
    font-weight: 700;
}
.micoapp-menu-toolbar .micoapp-toolbar-title p {
    margin: 0;
    color: #6b7280;
    font-size: 0.9rem;
}

.micoapp-menu-card {
    margin-bottom: 1.5rem;
}

.micoapp-menu-card-title {
    font-weight: 600;
    color: #374151;
    margin: 0 0 0.35rem 0;
    font-size: 1rem;
}

.micoapp-menu-card-desc {
    font-size: 0.85rem;
    color: #94a3b8;
    margin: 0 0 1rem 0;
}

.micoapp-menu-panels {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

.micoapp-menu-panel {
    min-height: 120px;
    padding: 0.75rem;
    background: #f8fafc;
    border: 1px dashed #e5e7eb;
    border-radius: 12px;
}

.micoapp-panel-active {
    background: #f0f7ff;
    border-color: #c5d4f0;
}

.micoapp-panel-title {
    font-size: 0.8rem;
    font-weight: 600;
    color: #6b7280;
    margin-bottom: 0.5rem;
}

.micoapp-drag-list {
    min-height: 80px;
}

.micoapp-menu-item {
    display: flex;
    align-items: center;
    padding: 0.6rem 0.75rem;
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    margin-bottom: 0.5rem;
    transition: all 0.2s;
}

.micoapp-menu-item:hover {
    background: #f1f5f9;
    border-color: #c5d4f0;
}

.micoapp-drag-handle {
    cursor: move;
    color: #94a3b8;
    margin-right: 0.75rem;
}
.micoapp-drag-handle:hover {
    color: #6b7280;
}

.micoapp-menu-name {
    flex: 1;
    font-weight: 500;
}

@media (max-width: 768px) {
    .micoapp-menu-panels {
        grid-template-columns: 1fr;
    }
}
</style>
